import client from './client';

const dati = (risposta) => risposta.data;

// Rubrica per persone: le identità WhatsApp stanno sotto la persona.
export const listEntries = (params) => client.get('/v1/address-book/', { params }).then(dati);
export const createEntry = (body) => client.post('/v1/address-book/', body).then(dati);
export const updateEntry = (id, body) => client.patch(`/v1/address-book/${id}/`, body).then(dati);
export const deleteEntry = (id) => client.delete(`/v1/address-book/${id}/`).then(dati);
export const bulkEntries = (body) => client.post('/v1/address-book/bulk/', body).then(dati);

export const importPreview = (body) => client.post('/v1/address-book-import/preview/', body).then(dati);
export const importCommit = (body) => client.post('/v1/address-book-import/commit/', body).then(dati);
export const recoverNumbers = (body) => client.post('/v1/address-book-recover-numbers/', body).then(dati);

// Membri di un gruppo WhatsApp: si leggono dal telefono, non dalla rubrica.
export const groupMembers = (id) => client.get(`/v1/address-book/${id}/members/`).then(dati);
export const importGroupMembers = (id, whatsapp_ids) =>
  client.post(`/v1/address-book/${id}/members/import/`, { whatsapp_ids }).then(dati);

export const listPeople = (params) => client.get('/v1/people/', { params }).then(dati);
export const updatePerson = (id, body) => client.patch(`/v1/people/${id}/`, body).then(dati);
export const personUsage = (id) => client.get(`/v1/people/${id}/usage/`).then(dati);
export const mergePreview = (body) => client.post('/v1/people/merge-preview/', body).then(dati);
export const merge = (body) => client.post('/v1/people/merge/', body).then(dati);
export const undoMerge = (id) => client.post(`/v1/people/merges/${id}/undo/`).then(dati);

export const listGroups = () => client.get('/v1/address-groups/').then(dati);
export const createGroup = (body) => client.post('/v1/address-groups/', body).then(dati);
export const updateGroup = (id, body) => client.patch(`/v1/address-groups/${id}/`, body).then(dati);
export const deleteGroup = (id) => client.delete(`/v1/address-groups/${id}/`).then(dati);
export const resolveGroup = (id, connection) =>
  client.post(`/v1/address-groups/${id}/resolve/`, { connection }).then(dati);

export const getPreferences = () => client.get('/v1/address-book-preferences/').then(dati);
export const setPreferences = (body) => client.put('/v1/address-book-preferences/', body).then(dati);

export function exportVcf(connection, group) {
  return client.get('/v1/address-book-export/', {
    params: { connection, ...(group ? { group } : {}) }, responseType: 'blob',
  }).then(dati);
}
